import styled from "styled-components";
import Pagination from "../../../../component/molecules/pagination";
import PretendardText from "../../../../component/atoms/text/pretendardText";
import { useEffect, useState } from "react";
import { formatNumberWithCommas } from "../../../../util/formatNumber";
import { fileUrl } from "../../../../api/api";
import Empty from "../../../../component/molecules/empty";
import MemberMerchApi from "../../../../api/memberMerch.api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { errorHandler } from "../../../../util/errorHandler";

const MerchList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  let { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);

  const [pagination, setPagination] = useState({
    size: 2, // 한 페이지에 표시될 게시글 수
    rangeSize: 0, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    getMemberMerchFunc();
  }, [currentPage]); // eslint-disable-line react-hooks/exhaustive-deps

  const [memberMerchList, setMemberMerchList] = useState([]);

  const getMemberMerchFunc = async () => {
    try {
      const data = {
        page: Number(currentPage),
        size: Number(pagination.size),
        memberId: id,
      };

      const response = (await MemberMerchApi.getList(data)).data.data;

      const dataList = response.content;
      const processedResponse = await Promise.all(
        dataList.map(async (item) => {
          const img = new Image();

          img.src = `${fileUrl}/${item.merch?.thumbnailServerFileName}`;

          img.onload = () => {
            item.imageIsValid = true;
          };

          img.onerror = () => {
            item.imageIsValid = false;
          };

          return item;
        })
      );

      setMemberMerchList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <MerchContainer>
          <MerchHeader>
            <PretendardText
              style={{
                color: "#f3f3f3",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "28px",
                letterSpacing: "-0.3%",
              }}
            >
              회원 학습 내역
            </PretendardText>
          </MerchHeader>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              columnGap: 8,
              alignItems: "center",
            }}
          >
            {memberMerchList.length > 0 ? (
              <img
                src="/assets/admin/icons/ico_pagination_left.svg"
                alt="arrow-left"
                style={{
                  width: 28,
                  height: 28,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (pagination.first || Number(currentPage) === 1) {
                    return;
                  }

                  setCurrentPage(Number(currentPage) - 1);
                }}
              />
            ) : (
              <></>
            )}

            {memberMerchList.length > 0 ? (
              memberMerchList.map((item, index) => {
                return (
                  <UserLearningContentContainer key={index}>
                    <div
                      style={{
                        width: 126,
                        height: 120,
                        background: "#313233",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {item.imageIsValid ? (
                        <img
                          style={{
                            width: 75,
                            height: 105,
                            objectFit: "cover",
                          }}
                          src={`${fileUrl}/${item.merch.thumbnailServerFileName}`}
                          alt=""
                        />
                      ) : (
                        <div
                          style={{
                            width: 75,
                            height: 105,
                            borderRadius: 5,
                            boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.25)",
                          }}
                        ></div>
                      )}
                    </div>

                    <UserLearningContentWrapper>
                      <UserLearningContentAuthor>
                        {item.merch.writer}
                      </UserLearningContentAuthor>
                      <UserLearningContentTitle>
                        {item.merch.title}
                      </UserLearningContentTitle>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                          marginBottom: 7.5,
                        }}
                      >
                        <img
                          style={{
                            width: 16,
                            height: 16,
                          }}
                          src="/assets/admin/icons/ico_star_fill.svg"
                          alt="별점"
                        />
                        <UserLearningContentReviewGradeText>
                          {item.merch.reviewScore}
                        </UserLearningContentReviewGradeText>
                        <UserLearningContentReviewGradeText>
                          ({formatNumberWithCommas(item.merch.reviewCount)})
                        </UserLearningContentReviewGradeText>
                      </div>
                      <PretendardText
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          lineHeight: "22.4px",
                          color: "#3a96df",
                        }}
                      >
                        {item.progressPercent}%
                      </PretendardText>
                    </UserLearningContentWrapper>
                  </UserLearningContentContainer>
                );
              })
            ) : (
              <Empty />
            )}

            {memberMerchList.length > 0 ? (
              <img
                src="/assets/admin/icons/ico_pagination_right.svg"
                alt="arrow-right"
                style={{
                  width: 28,
                  height: 28,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (
                    pagination.last ||
                    Number(currentPage) === pagination.totalPages
                  ) {
                    return;
                  }

                  setCurrentPage(Number(currentPage) + 1);
                }}
              />
            ) : (
              <></>
            )}
          </div>
        </MerchContainer>
      </div>
    </>
  );
};

export default MerchList;

const MerchContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  min-height: 565px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MerchHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 59px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 30px;
`;

const UserLearningContentContainer = styled.div.attrs((props) => {})`
  display: flex;
  width: 473px;
  height: 160px;
  padding: 20px;
  gap: 20px;
  border-radius: 10px;
  background-color: #272829;
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.13);
`;

const UserLearningContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
`;

const UserLearningContentAuthor = styled(PretendardText).attrs((props) => {})`
  font-weight: 400;
  font-size: 12px;
  line-height: 15.6px;
  color: #aaa;
  margin-bottom: 7px;
`;

const UserLearningContentTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 18px;
  line-height: 24.3px;
  color: #aaa;
  width: 207px;
  min-height: 48px;
`;

const UserLearningContentReviewGradeText = styled(PretendardText).attrs(
  (props) => {}
)`
  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
  color: #aaa;
`;
